import { render, staticRenderFns } from "./MedicationPlanForm.vue?vue&type=template&id=ef253c28&scoped=true&"
import script from "./MedicationPlanForm.vue?vue&type=script&lang=js&"
export * from "./MedicationPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef253c28",
  null
  
)

export default component.exports